export const env = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001/api',
  wsUrl: import.meta.env.VITE_WS_URL || 'http://localhost:3001/events',
  vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY || '',
} as const;

function validateEnv(): void {
  const required = ['VITE_API_URL', 'VITE_WS_URL'] as const;
  const missing = required.filter((key) => !import.meta.env[key]);
  if (missing.length > 0 && import.meta.env.PROD) {
    console.error(`[Config] Missing env vars: ${missing.join(', ')}`);
  }
}

validateEnv();
